export default __webpack_public_path__ + "static/mars-close-1-6267568b913b00d7cee51357781ee442.webp";